import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { take } from '@beef/utils';
export var baseEventFields = ['type', 'altKey', 'ctrlKey', 'shiftKey', 'metaKey'];
export var mouseEventFields = [].concat(baseEventFields, ['clientX', 'clientY', 'screenX', 'screenY', 'button']);
export var keyboardEventFields = [].concat(baseEventFields, ['key', 'keyCode', 'code', 'charCode']);
export var wheelEventFields = [].concat(baseEventFields, ['deltaX', 'deltaY', 'deltaMode']);
export var injectStandardEventProps = function injectStandardEventProps(event) {
  return _objectSpread(_objectSpread({}, event), {}, {
    bubbles: true,
    cancellable: true
  });
};
export var pickImportantMouseEventFields = function pickImportantMouseEventFields(event) {
  return take(mouseEventFields, event);
};
export var pickImportantKeyboardEventFields = function pickImportantKeyboardEventFields(event) {
  return take(keyboardEventFields, event);
};
export var pickImportantWheelEventFields = function pickImportantWheelEventFields(event) {
  return take(wheelEventFields, event);
};
export var offsetMouseEvent = function offsetMouseEvent(event, _ref) {
  var left = _ref.left,
    top = _ref.top;
  return _objectSpread(_objectSpread({}, event), {}, {
    screenX: event.screenX + window.scrollX,
    screenY: event.screenY + window.scrollY,
    clientX: event.clientX + left,
    clientY: event.clientY + top,
    pageX: event.clientX + left + window.scrollX,
    pageY: event.clientY + top + window.scrollY
  });
};